import { render } from "./EventCard.vue?vue&type=template&id=643d6bd2&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=643d6bd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-643d6bd2"

export default script